import axios from 'axios';

const frontendDataCache = {};

export const loadHookEventsFrontendData = async (funnelPageId, lang = 'zh-TW') => {
	if (!funnelPageId) {
		return null;
	}

	const cacheKey = `${funnelPageId}:${lang}`;
	if (!frontendDataCache[cacheKey]) {
		frontendDataCache[cacheKey] = axios
			.get(`/hook-events/ajax-load-frontend-data/${funnelPageId}/${lang}`)
			.then((response) => response.data)
			.catch((error) => {
				delete frontendDataCache[cacheKey];
				throw error;
			});
	}

	return frontendDataCache[cacheKey];
};
